<script>
import { generateToken } from '@shared/utils/common'
import FormLabel from './FormLabel'

export default {
  functional: true,
  props: {
    label: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
    descriptionType: {
      type: String,
      default: 'help',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    wrap: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    invalid: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      required: false,
    },
    dataTest: {
      type: String,
      required: false,
    },
    id: {
      type: String,
      default: () => `field_${generateToken(6)}`,
    },
  },
  render: (h, { props, data, listeners, attrs, slots }) => {

    const label = <FormLabel
      id={props.id}
      label={props.label}
      description={props.description}
      descriptionType={props.descriptionType}
      required={props.required}
      error={props.error}
      dirty={props.invalid}
      disabled={props.disabled} />

    const fakeInput = <div
      class="position-relative d-flex align-items-center"
      {...attrs}
    >
      <div
        disabled={props.disabled}
        class={ [
          'form-input-button__display form-control py-0',
          !props.wrap && 'form-input-button__display--nowrap',
          props.invalid && 'invalid' ] }
        data-test={props.dataTest}
        id={props.id}
      >
        { slots().default || '' }
      </div>
    </div>

    fakeInput.data.on = listeners

    return (
      <div class= { [ 'form-input-button form-element', data.staticClass ] }>
        { props.label ? label : '' }
        { fakeInput }
      </div>
    )
  },
}
</script>

<style lang="scss">
.form-input-button {
  .form-control {
    min-height: 36px;
    overflow: hidden;
    transition: box-shadow ease 250ms;
  }
  .form-control[readonly][disabled] {
    background-color: transparent;
  }
  .form-control[readonly] {
    background-color: white;
  }
  .form-control:not([readonly]):not([disabled]):hover {
    cursor: pointer;
    box-shadow: 0 2px 5px rgba(var(--shadow-rgb), 0.1);
  }
  .form-input-button__display:not([readonly]):not([disabled]) {
    background-image: none;
    border-color: var(--gray);
    background: white;
  }
  .form-input-button__display.invalid:not([readonly]):not([disabled]) {
    border-color: var(--danger);
  }
  .form-input-button__display {
    line-height: 35px;
    padding-right: 8px;
    pointer-events: initial;
  }
  .form-input-button__display--nowrap {
    white-space: nowrap;
    overflow-x: hidden;
    text-overflow: ellipsis;
  }
  .form-input-button__select {
    position: absolute;
    width: 40px;
    min-height: 36px;
    right: 1px;
    top: 1px;
    padding: 4px 8px;
    text-align: center;
  }
}
</style>
